import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { motion, useInView } from 'framer-motion'
import { ClipboardList, Hourglass } from 'lucide-react'

import { cn } from '@/utils'

import { containerVariants, DetailDrawerType } from '../../constants'
import { useOrgLevelMetric } from '../../hooks/useOrgLevelMetric'
import { useDashboardStore } from '../../store'
import { MetricCard } from '../MetricCard'

import { MostActiveUser } from './MostActiveUser'

export const OrgLevel: React.FC = () => {
  const { t } = useTranslation()
  const { setDisplayedDrawer } = useDashboardStore()

  const {
    projectMetric,
    isLoadingNoOfProjects,
    lateDeliverablesMetric,
    isLoadingLateDeliverables,
    commentDensityMetric,
    isLoadingCommentDensity,
  } = useOrgLevelMetric()

  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-100px 0px' })

  return (
    <>
      <h1 className="font-semibold text-xl text-primary-900 m-0">
        Organization Dashboard
      </h1>
      <motion.div
        ref={ref}
        className={cn(
          'space-y-5',
          'lg:flex lg:flex-wrap lg:space-y-0 lg:gap-5'
        )}
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
      >
        <MetricCard
          title={t('dashboard.metrics.noOfProjects')}
          icon={ClipboardList}
          value={projectMetric?.metric}
          onViewAll={() => setDisplayedDrawer(DetailDrawerType.NO_OF_PROJECTS)}
          isLoading={isLoadingNoOfProjects}
        />
        <MetricCard
          title={t('dashboard.metrics.lateDeliverables')}
          icon={Hourglass}
          value={lateDeliverablesMetric?.metric}
          onViewAll={() =>
            setDisplayedDrawer(DetailDrawerType.LATE_DELIVERABLES)
          }
          isLoading={isLoadingLateDeliverables}
        />
        <MetricCard
          title={t('dashboard.metrics.commentDensity')}
          icon={Hourglass}
          value={commentDensityMetric?.metric}
          unit={t('dashboard.units.commentPerFile')}
          isDecimalValue
          onViewAll={() => setDisplayedDrawer(DetailDrawerType.COMMENT_DENSITY)}
          isLoading={isLoadingCommentDensity}
        />
      </motion.div>
      <MostActiveUser />
    </>
  )
}
